import { render, staticRenderFns } from "./RedirectOverview.vue?vue&type=template&id=af4be706&scoped=true"
import script from "./RedirectOverview.vue?vue&type=script&lang=js"
export * from "./RedirectOverview.vue?vue&type=script&lang=js"
import style0 from "./RedirectOverview.vue?vue&type=style&index=0&id=af4be706&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4be706",
  null
  
)

export default component.exports